'use client'

import { useTranslations } from 'next-intl'

import { AppStore, GooglePlay } from '@/shared/asset'
import { useAirbridge } from '@/shared/config'
import { Button, MobileLayout } from '@/shared/ui'

export const MobileAppDownload = () => {
  const t = useTranslations('main.app_download')

  const airbridge = useAirbridge()

  const handleButtonClick = () => {
    airbridge.openDeeplink({
      type: 'click',
      ctaParams: {
        cta_param_1: 'main',
        cta_param_2: 'app_download',
        cta_param_3: '',
      },
    })
  }

  return (
    <section
      style={{
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.65) 0%, rgba(255, 255, 255, 0.65) 100%), linear-gradient(90deg, rgba(78, 144, 249, 0.00) 0%, #4E90F9 100%), linear-gradient(0deg, #895FFC 0%, #895FFC 100%), var(--Gray-gray-900, #252525)',
      }}
    >
      <MobileLayout className="py-12.5">
        <p className="typo-label1 mb-3 text-center font-semibold text-gray-900">
          {t('subtitle')}
        </p>

        <h2 className="typo-title3 mb-6 shrink-0 text-center text-black *:block">
          <span className="font-normal">{t('title.line1')}</span>
          <span className="font-bold">{t('title.line2')}</span>
        </h2>

        <div className="flex flex-col items-center gap-3">
          <Button
            variant="outline"
            size="large"
            shape="pill"
            className="typo-body1 h-12 w-50 gap-2.5 border-none font-bold text-black"
            onClick={handleButtonClick}
          >
            <AppStore className="h-6! w-6!" />
            App Store
          </Button>
          <Button
            variant="outline"
            size="large"
            shape="pill"
            className="typo-body1 h-12 w-50 gap-2.5 border-none font-bold text-black"
            onClick={handleButtonClick}
          >
            <GooglePlay className="h-6! w-6!" />
            Google Play
          </Button>
        </div>
      </MobileLayout>
    </section>
  )
}
